import React from "react"
import cx from "classnames"
import Img from "gatsby-image"

interface SpeakerProps {
  children: React.ReactNode
}
function Speaker(props: SpeakerProps) {
  return <div className="mb-9">{props.children}</div>
}

interface SpeakerImageProps {
  image: string
}

export function SpeakerImageRound(props: SpeakerImageProps) {
  return <Img fluid={props.image} className="w-full h-full rounded-full" loading="eager" />
}

export function SpeakerImage(props: SpeakerImageProps) {
  return <Img fluid={props.image} className="mb-4 rounded-8" />
}

interface SpeakerHeadingProps {
  name: string
  mode: "light" | "dark"
}
export function SpeakerName(props: SpeakerHeadingProps) {
  return (
    <div className="mb-1">
      <h4
        className={cx("text-h5 leading-h5 tracking-30 font-serif", {
          "text-white": props.mode === "light",
          "text-body": props.mode === "dark",
        })}
      >
        {props.name}
      </h4>
    </div>
  )
}

interface SpeakerDescProps {
  desc?: string
  mode: "light" | "dark"
}
export function SpeakerDesc(props: SpeakerDescProps) {
  if (!props.desc) return null
  return (
    <p
      className={cx("text-p tracking-h6 tracking-12", {
        "text-white": props.mode === "light",
        "text-body": props.mode === "dark",
      })}
    >
      {props.desc}
    </p>
  )
}

interface SocialLinkListProps {
  children: React.ReactNode
}
export function SocialLinkList(props: SocialLinkListProps) {
  return <div className="mb-4 flex space-x-1">{props.children}</div>
}

interface SocialLinkProps {
  id: number
  url: string
  icon: React.ReactNode
}
export function SocialLink(props: SocialLinkProps) {
  const { id, url, icon } = props
  return (
    <a key={id} rel="noopener noreferrer" target="_blank" href={url}>
      {icon}
    </a>
  )
}

Speaker.Image = SpeakerImage
Speaker.ImageRound = SpeakerImageRound
Speaker.Name = SpeakerName
Speaker.Desc = SpeakerDesc
Speaker.SocialLinkList = SocialLinkList
Speaker.SocialLink = SocialLink

export default Speaker
